import React from "react";
import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <div className="logo-wrapper">
      <Link to="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 128 128"
          fill="white"
        >
          <path d="M 14 13 C 6.8 13 1 18.8 1 26 L 1 104 C 1 111.2 6.8 117 14 117 L 114 117 C 121.2 117 127 111.2 127 104 L 127 26 C 127 18.8 121.2 13 114 13 L 14 13 z M 14 19 L 114 19 C 117.9 19 121 22.1 121 26 L 121 60.400391 C 121 62.200391 119.39961 63.600391 117.59961 63.400391 C 74.199609 56.800391 44.2 72.800391 32.5 108.90039 C 32.1 110.10039 30.999609 111 29.599609 111 L 14 111 C 10.1 111 7 107.9 7 104 L 7 26 C 7 22.1 10.1 19 14 19 z M 36 30.974609 C 31.65 30.974609 27.3 32.65 24 36 C 17.4 42.6 17.4 53.399609 24 60.099609 C 27.3 63.399609 31.7 65.099609 36 65.099609 C 40.3 65.099609 44.7 63.399609 48 60.099609 C 54.6 53.499609 54.6 42.7 48 36 C 44.7 32.65 40.35 30.974609 36 30.974609 z"></path>
        </svg>
        <span className="logo__text">PICXEL</span>
      </Link>
    </div>
  );
}
